/**
 * ProfileCompletenessBadge — F-002 Phase 4 (IMPL-P4-010).
 *
 * Indicatore globale dello stato del profilo di fatturazione, montato
 * nell'header di {@link AppLayout}. Rende:
 *  - Stato `present` + `isComplete === true` → Badge verde "Profilo completo"
 *  - Tutti gli altri stati (`absent`, `error`, `present` ma incompleto) →
 *    Button outline con `Link` a `/app/profilo` "Completa profilo"
 *  - Stato `loading` → null (nessun flash sotto/sopra il logo durante /me)
 *
 * Visibilità: nascosto sotto il breakpoint `sm` per non saturare la mobile bar.
 *
 * Deve essere montato dentro `<BillingProfileProvider>` — la presenza del
 * provider è verificata da `useBillingProfile()` (lancia se manca).
 */
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import { useBillingProfile } from '../hooks/useBillingProfile';

export function ProfileCompletenessBadge() {
  const { status, isComplete } = useBillingProfile();

  if (status === 'loading') return null;

  if (status === 'present' && isComplete) {
    return (
      <Badge
        variant="secondary"
        className="hidden gap-1 border-green-200 bg-green-50 text-green-700 sm:inline-flex"
        aria-label="Profilo di fatturazione completo"
      >
        <CheckCircle2 className="h-3.5 w-3.5" aria-hidden="true" />
        <span>Profilo completo</span>
      </Badge>
    );
  }

  return (
    <Button
      asChild
      size="sm"
      variant="outline"
      className="hidden border-amber-300 text-amber-900 hover:bg-amber-50 sm:inline-flex"
    >
      <Link to="/app/profilo" aria-label="Profilo di fatturazione incompleto: completa ora">
        Completa profilo
      </Link>
    </Button>
  );
}
